// extracted by mini-css-extract-plugin
module.exports = {"brand-logo":"BrandLogo_brand-logo__Fpu4l"};